import memoize from 'lodash/memoize'
import { ContextApi } from '@pancakeswap/localization'
import { PageMeta } from './types'
import { ASSET_CDN } from './endpoints'

export const DEFAULT_META: PageMeta = {
  title: 'pDex',
  description:
    'Liquidity and trading infrastructure for the PulseChain Renaissance',
  image: `https://pdex.vision/logo.png`,
}

interface PathList {
  paths: { [path: string]: { title: string; basePath?: boolean; description?: string; image?: string } }
  defaultTitleSuffix: string
}

const getPathList = (t: ContextApi['t']): PathList => {
  return {
    paths: {
      '/': { title: t('Home') },
      '/swap': { basePath: true, title: t('Swap'), image: `https://pdex.vision/logo.png` },
      '/positions': { basePath: true, title: t('Positions'), image: `https://pdex.vision/logo.png` },
      '/xnineinch': { basePath: true, title: t('pDex'), image: `https://pdex.vision/logo.png` },
      '/dividends': { basePath: true, title: t('Dividends'), image: `https://pdex.vision/logo.png` },
      '/lanchpad': { basePath: true, title: t('Launchpad'), image: `https://pdex.vision/logo.png` },
      '/booster': { basePath: true, title: t('Yield Booster'), image: `https://pdex.vision/logo.png` },
      '/gauge': { basePath: true, title: t('Gauge'), image: `https://pdex.vision/logo.png` },
      '/analytics': { basePath: true, title: t('Analytics'), image: `https://pdex.vision/logo.png` },

      '/limit-orders': { basePath: true, title: t('Limit Orders'), image: `https://pdex.vision/logo.png` },
      '/add': { basePath: true, title: t('Add Liquidity'), image: `https://pdex.vision/logo.png` },
      '/remove': { basePath: true, title: t('Remove Liquidity'), image: `https://pdex.vision/logo.png` },
      '/liquidity': { title: t('Liquidity'), image: `https://pdex.vision/logo.png` },
      '/find': { title: t('Import Pool') },
      '/competition': { title: t('Trading Battle') },
      '/prediction': { title: t('Prediction'), image: `https://pdex.vision/logo.png` },
      '/prediction/leaderboard': { title: t('Leaderboard'), image: `https://pdex.vision/logo.png` },
      '/farms': { title: t('Farms'), image: `${ASSET_CDN}/web/og/farms.jpg` },
      '/farms/auction': { title: t('Farm Auctions'), image: `https://pdex.vision/logo.png` },
      '/pools': { title: t('Pools'), image: `https://pdex.vision/logo.png` },
      '/lottery': { title: t('Lottery'), image: `https://pdex.vision/logo.png` },
      '/ifo': { title: t('Initial Farm Offering'), image: `https://pdex.vision/logo.png` },
      '/teams': { basePath: true, title: t('Leaderboard'), image: `https://pdex.vision/logo.png` },
      '/voting': { basePath: true, title: t('Voting'), image: `https://pdex.vision/logo.png` },
      '/voting/proposal': { title: t('Proposals'), image: `https://pdex.vision/logo.png` },
      '/voting/proposal/create': { title: t('Make a Proposal'), image: `https://pdex.vision/logo.png` },
      '/info': {
        title: `${t('Overview')} - ${t('Info')}`,
        description: 'View statistics for pDex exchanges.',
        image: `https://pdex.vision/logo.png`,
      },
      '/info/pairs': {
        title: `${t('Pairs')} - ${t('Info')}`,
        description: 'View statistics for pDex exchanges.',
        image: `https://pdex.vision/logo.png`,
      },
      '/info/tokens': {
        title: `${t('Tokens')} - ${t('Info')}`,
        description: 'View statistics for pDex exchanges.',
        image: `https://pdex.vision/logo.png`,
      },
      '/nfts': { title: t('NFT Marketplace'), image: `https://pdex.vision/logo.png` },
      '/nfts/collections': { basePath: true, title: t('Collections'), image: `https://pdex.vision/logo.png` },
      '/nfts/activity': { title: t('Activity'), image: `https://pdex.vision/logo.png` },
      '/profile': { basePath: true, title: t('Profile') },
      '/pancake-squad': { basePath: true, title: t('Pancake Squad') },
      '/pottery': { basePath: true, title: t('Pottery'), image: `https://pdex.vision/logo.png` },
    },
    defaultTitleSuffix: t('pDex'),
  }
}

export const getCustomMeta = memoize(
  (path: string, t: ContextApi['t'], _: string): PageMeta => {
    const pathList = getPathList(t)
    const pathMetadata =
      pathList.paths[path] ??
      pathList.paths[Object.entries(pathList.paths).find(([url, data]) => data.basePath && path.startsWith(url))?.[0]]

    if (pathMetadata) {
      return {
        title: `${pathMetadata.title}`,
        // ...(pathMetadata.description && { description: pathMetadata.description }),
        // image: pathMetadata.image,
      }
    }
    return undefined
  },
  (path, t, locale) => `${path}#${locale}`,
)
